import { api_GET, api_POST, api_PUT } from "./_api.js";

const regional_api = {
    getList: (status = "Ativo") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Regional/Getlist/${status}`)
                .then(result => {
                    resolve(result) 
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Regional/GetItem/${id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Regional`, json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (regional) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Regional`, regional)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default regional_api;
